var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.8,
    height: 30.8,
    viewBox: "0 0 30.8 30.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Assignee",
    "data-name": "Add Assignee",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M345.9,267.736a14.9,14.9,0,1,1-14.9-14.9,14.9,14.9,0,0,1,14.9,14.9",
    transform: "translate(-316.102 -252.836)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M403.438,329.26h-4.473v-4.424a1.08,1.08,0,0,0-2.159,0v4.424h-4.473a1.044,1.044,0,1,0,0,2.086H396.8v4.22a1.08,1.08,0,0,0,2.159,0v-4.22h4.473a1.044,1.044,0,1,0,0-2.086",
    transform: "translate(-382.985 -315.3)",
    fill: "#a7a7a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plusCircle.6f7e19d2bd7b6c7e66f22d567d01aa31.svg";
export { ForwardRef as ReactComponent };